// Meta Pixel (Facebook/Instagram Ads) — carrega só se VITE_META_PIXEL_ID
// estiver configurado. Em ambientes sem o ID (dev, branch preview), vira no-op.
// Documentação: https://developers.facebook.com/docs/meta-pixel

const PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID || '';

let bootstrapped = false;
export function initMetaPixel() {
  if (bootstrapped || typeof window === 'undefined' || !PIXEL_ID) return;
  bootstrapped = true;
  try {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  } catch {
    /* pixel não pode quebrar o app */
  }
}

// Use os nomes de evento padrão do Meta (CompleteRegistration, Purchase, Lead...)
// pra caírem certo no Gerenciador de Eventos e servirem de evento de otimização
// nas campanhas.
// ID único por disparo, pra deduplicar com uma futura Conversions API.
export function newEventId() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  } catch { /* cai no fallback */ }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

// Eventos que NÃO são padrão do Meta (OnboardingCompleted, LeadQualificado...)
// vão por trackCustom; eventos padrão continuam em trackMetaEvent.
export function trackMetaCustomEvent(name, params = {}, eventId = newEventId()) {
  if (typeof window === 'undefined' || !window.fbq) return;
  try {
    window.fbq('trackCustom', String(name || 'CustomEvent'), params, eventId ? { eventID: eventId } : undefined);
  } catch { /* noop */ }
}

export function trackMetaEvent(name, params = {}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  try { window.fbq('track', String(name || 'CustomEvent'), params); } catch { /* noop */ }
}
